import { Navigate } from "react-router-dom";
import { poolTypeById } from "../poolTypes";

// A Discontinued Pool Type has no Programs or Tips to list, so App.js sends its
// pools and tips URLs (and Megastrike's empty Results page) to its Results in the
// archive instead of rendering empty lists.
const ArchiveRedirect = ({ pool_id }) => <Navigate to={"/archive/" + poolTypeById(pool_id).slugs.archive} replace />;

export default ArchiveRedirect;
